import React from 'react';
import styled from '@emotion/styled';
import { __ } from '../../../../helpers/TranslationService';
import * as InclusivesIcons from '../../helper/InclusiveIcons';
import { badgeTypes } from './helpers/search-helpers';
import {
    IExperience,
    IMobileSearchResultCruise,
    IMobileSearchResultSail,
} from '../../../../interfaces/ISearchApi';
import { SearchResultItemBadge } from './SearchResultItemBadge';

interface IProps {
    iconProps: {
        width: number;
        height: number;
    };
    typeOfBadge: string;
    experiences: IExperience[];
    selectedSail?: IMobileSearchResultSail;
    cruise: IMobileSearchResultCruise;
    packagesUrl?: string;
    icons: { icon: string; text: string }[];
    isCruise1st?: boolean;
    isPackage?: boolean;
}

const StyledContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 16px 0 0 0;
    margin: 0 16px 16px 16px;
    gap: 4px;
    position: relative;
`;

const FeaturePill = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    display: flex;
    align-items: center;
    background: ${(props) => props.theme.background.layerSecondary};
    border: 2px solid ${(props) => props.theme.border.onLayer};
    border-radius: 8px;
    padding: 8px;
    span {
        margin-left: 4px;
    }
`;

// Defined order as per DREAM-17751
// Cruise, Flight, Additional Flight, Train Ride,Hotel, Tour, Cruise Tour, Bicycle Tour, All Inclusive, Free Wifi, Drinks, Full Board, Half Board, Tips, Children Travel Free, Breakfest

const INCLUSIVES_ORDER = [
    'CruiseIcon',
    'FlightIcon',
    'FlightExtraIcon',
    'TrainIcon',
    'HotelIcon',
    'TourIcon',
    'BicycleTourIcon',
    'AllInclusiveIcon',
    'FreeWiFiIcon',
    'WineIcon',
    'FullBoardIcon',
    'MoneyIcon',
    'KidsIcon',
    'BreakfastIcon',
    'FeatureOnBoardCreditIcon',
    'FeatureParkingSpaceIcon',
];

export const SearchResultItemFeatures = ({
    icons,
    iconProps,
    typeOfBadge,
    experiences,
    cruise,
    selectedSail,
    packagesUrl,
    isCruise1st,
    isPackage,
}: IProps) => {
    const inclusives = React.useMemo(
        () =>
            [{ icon: 'CruiseIcon', text: 'cruiseData.cruiseVal' }, ...icons]
                ?.filter((item) => INCLUSIVES_ORDER.includes(item?.icon) && item?.icon)
                ?.sort((a, b) => {
                    const indexA = INCLUSIVES_ORDER.indexOf(a.icon);
                    const indexB = INCLUSIVES_ORDER.indexOf(b.icon);
                    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
                    if (indexA !== -1) return -1;
                    if (indexB !== -1) return 1;
                    return 0;
                }),
        [icons],
    );

    const isExperienceBadgeType = typeOfBadge === badgeTypes.experience;

    return (
        <StyledContainer>
            {!!experiences.length &&
                experiences.map((exp) => {
                    return (
                        <SearchResultItemBadge
                            isExperienceBadgeType={isExperienceBadgeType}
                            isCruise1st={isCruise1st}
                            packageInfo={exp}
                            iconProps={iconProps}
                            cruise={cruise}
                            selectedSail={selectedSail}
                            typeOfBadge={typeOfBadge}
                            packagesUrl={packagesUrl}
                        />
                    );
                })}
            {experiences.length === 0 && isPackage && (
                <SearchResultItemBadge
                    isCruise1st={isCruise1st}
                    iconProps={iconProps}
                    cruise={cruise}
                    selectedSail={selectedSail}
                    typeOfBadge={typeOfBadge}
                    packagesUrl={packagesUrl}
                />
            )}
            {}
            {inclusives?.map((item) => {
                const IconComp = InclusivesIcons[item?.icon];
                return (
                    <FeaturePill key={item?.icon}>
                        {IconComp && <IconComp width={12} height={12} />}
                        <span>{__(item?.text, 'dreamlines')}</span>
                    </FeaturePill>
                );
            })}
        </StyledContainer>
    );
};
